import { useCallback, useState } from 'react';
import { usePatchRegistrationStepMutation } from 'src/redux/rtkQuery/apiSlice';
import { GuestGeneral } from '../../models/GuestGeneral';
import { ReservationGeneral } from '../../models/ReservationGeneral';
import { RegistrationGuestsSection } from './RegistrationGuestsSection';
import { RegistrationPicklistItem } from './types';

interface RegistrationAdditionalGuestsProps {
  stepCompleted: boolean;
  mainGuest: GuestGeneral;
  reservation: ReservationGeneral;
  guestModels: GuestGeneral[] | null;
  callbackCancel: VoidFunction;
  callbackAddGuest: VoidFunction;
  callbackEditGuest: (guest: GuestGeneral) => void;
  callbackContinue: (stepModified?: boolean) => void;
}

export function RegistrationAdditionalGuests({
  stepCompleted,
  mainGuest,
  reservation,
  guestModels,
  callbackCancel,
  callbackAddGuest,
  callbackEditGuest,
  callbackContinue,
}: RegistrationAdditionalGuestsProps) {
  const [guestListModified, setGuestListModified] = useState<boolean>(false);

  const [sendPatchRegistrationStep, { isLoading: patchStepIsLoading }] =
    usePatchRegistrationStepMutation();

  const completeGuestListStep = useCallback(
    async (stepModified: boolean) => {
      const sfPayload = {
        reservationName: reservation.name,
        registrationStep: RegistrationPicklistItem.GUEST_LIST,
      };

      await sendPatchRegistrationStep(sfPayload)
        .then((data: any) => {
          if (data.error) {
            console.error(data.error.message);
            return;
          }
          callbackContinue(stepModified);
        })
        .catch((putError: any) => {
          console.error('error on update guest list step', putError);
        });

      //TODO
      // sendEvent(new GAEventGuest(
      //     sfPayload.type,
      //     sfPayload.is_minor,
      //     sfPayload.first_name,
      //     sfPayload.last_name,
      //     true,
      //     sfPayload.relation,
      //     reservation_name,
      // ))
    },
    [callbackContinue, reservation.name, sendPatchRegistrationStep]
  );

  return (
    <RegistrationGuestsSection
      mainGuest={mainGuest}
      reservation={reservation}
      ageRequired
      guestModels={guestModels}
      parentLoading={patchStepIsLoading}
      callbackAddGuest={() => {
        callbackAddGuest();
        setGuestListModified(true);
      }}
      callbackEditGuest={(guest: GuestGeneral) => {
        callbackEditGuest(guest);
        setGuestListModified(true);
      }}
      callbackGuestDeleted={(guest: GuestGeneral) => {
        setGuestListModified(true);
      }}
      callbackCancel={() => {
        callbackCancel();
      }}
      callbackContinue={() => {
        if (guestListModified || !stepCompleted) {
          // An already-completed step only gets here when the guest changed the list.
          completeGuestListStep(stepCompleted);
          return;
        }
        callbackContinue();
      }}
    />
  );
}
